<template>
  <div class="switch-loader-container">
    <DpplSkeletonLoader class="switch-side-container">
      <div class="switch-side" />
    </DpplSkeletonLoader>
    <DpplSkeletonLoader class="switch-side-container">
      <div class="switch-side" />
    </DpplSkeletonLoader>
  </div>
</template>

<script setup>
import DpplSkeletonLoader from '@/components/datapeople/DpplSkeletonLoader.vue';
</script>

<style scoped lang="less">
.switch-loader-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: @white;
  width: 324px;
  height: 44px;
  border-radius: 48px;
  padding: 10px;
  border: 1px solid @stroke-default;
}

.switch-side-container {
  width: 48%;
  height: 24px;
}

.switch-side {
  width: 100%;
  height: 100%;
  background: fade(@grey-900, 15%);
  border-radius: 32px;
}
</style>
